<template>
    <div  class="main-content" id="home" :style="{backgroundImage: 'url(' + imgBg + ')' }">
        <div class="triangle">
            <div class="triangle-left">
            </div>

            <div class="triangle-right">
            </div>
        </div>

        <div class="title">
            <div class="title-content">
                平台介绍
            </div>
        </div>

        <div class="title2">
            <div class="title-content2">
                设备后市场运营服务解决方案
            </div>
        </div>
        <div class="article">
            <div class="article-content" align="left" >
                <p style="text-indent:2em">
                   MRO工业互联网平台定位于为设备制造商提供面向设备后市场的运营解决方案将制造商与使用方进行有效的信息联通，围绕设备提供售后咨询、专业维修、备件销售等服务功能。
                </p>
            </div>
        </div>

        <div class="img">
            <img :src="img" style="width: 70%">
        </div>
<!--        {{width}}-->
    </div>
</template>

<script>
    import imgBg from '@/assets/index/img/BG-平台介绍.png'
    import img from '@/assets/index/img/架构图.png'
    export default {
        name: "stageIntro",
        data(){
            return{
                imgBg:imgBg,
                img:img,
                width:100
            }
        },
        created(){
            this.width=document.body.clientWidth
        },
        mounted(){
            window.addEventListener('resize', this.handelWidth, false)
        },
        beforeDestroy(){
            window.removeEventListener("resize",this.handelWidth, false)
        },
        methods:{
            handelWidth(){
                this.width=document.body.clientWidth
            }
        }
    }
</script>

<style scoped>
    .triangle{
        width: 100%;
        position: absolute;
        top: 64px;
        padding-right: 36%;
        padding-left: 34%;
    }
    .triangle-left{
        border-color:  #fff #0F1326 #fff #fff;
        border-style: solid;
        border-width: 6px 10px 6px  0px;
        height: 0;
        width: 0;
        float: left;
    }

    .triangle-right{
        border-color:  #fff #fff #fff #0F1326;
        border-style: solid;
        border-width: 6px 0px 6px 10px;
        height: 0;
        width: 0;
        float: right;
    }
    .title{
        position: absolute;
        width: 100%;
        top: 45px;
    }
    .title-content{
        margin: 0 auto;
        /*width:300px;*/
        height:50px;
        font-size:36px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:50px;
        color:rgba(15,19,38,1);
        letter-spacing:20px;
        opacity:1;
    }
    .title2{
        position: absolute;
        width: 100%;
        top: 135px;
    }
    .title-content2{
        margin: 0 auto;
        width:700px;
        height:38px;
        font-size:28px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:38px;
        color:rgba(15,19,38,1);
        letter-spacing:25px;
        opacity:1;
    }
    .article{
        position: absolute;
        width: 100%;
        top: 188px;
    }
    .article-content{
        margin: 0 auto;
        width:900px;
        height:52px;
        font-size:16px;
        font-family:Alibaba PuHuiTi;
        font-weight:400;
        line-height:26px;
        color:rgba(15,19,38,1);
        letter-spacing:3px;
        opacity:1;
    }
    .img{
        position: absolute;
        width: 100%;
        top: 330px;
    }


</style>
